import React from 'react'
import { BButton, BIcon } from '@prague-digi/ui-components'
import classNames from '@prague-digi/class-names'

import { NotificationSeverityEnum } from '../../redux/reducers/notification/model'

import styles from './styles.scss'

interface Props {
  description?: any
  iconClass?: string
  isMarginBottom?: boolean
  isMarginTop?: boolean
  onClose?: any
  ownIconImg?: any
  severity?: NotificationSeverityEnum // TODO - not implemented all the severity types
  title?: any
  type?: string
}

export const Notification = ({
  description,
  isMarginBottom = true,
  isMarginTop = false,
  onClose,
  ownIconImg,
  title,
  type,
}: Props) => {
  const cx = classNames(styles.alert, {
    [styles.alertSuccess]: type === 'success',
    [styles.marginBottom]: isMarginBottom,
    [styles.marginTop]: isMarginTop,
  })
  const iconName = `alert__${type || 'warning'}`

  return (
    <div className={cx}>
      <div className={styles.iconContainer}>
        {!ownIconImg && <BIcon name={iconName} />}
        {!!ownIconImg && <img alt="icon" src={ownIconImg} />}
      </div>
      <div className={styles.contentContainer}>
        {!!title && <div className={styles.title}>{title}</div>}
        {!!description && <div className={styles.description}>{description}</div>}
      </div>
      {!!onClose && (
        <div className={styles.closeButtonContainer}>
          <BButton testid="closeButton" theme={styles.closeButton} color="link" onClick={onClose}>
            <BIcon name="delete" />
          </BButton>
        </div>
      )}
    </div>
  )
}

export default Notification
